import React, {useEffect, useRef,useState } from "react"; 
import { getEnvUrl,getToken } from "../../../utils/Api"; 
import Loader from "../../common/loader";
import CreateSystemUser from "./popups/createSystemUser";
import ViewSystemUser from "./popups/viewSystemUser";
import { deleteSystemUserByID } from "../../../Services/User/SystemUserService";
import { toast } from 'react-toastify';
import { checkPermissions } from "../../../Services/User/User";
import { useNavigate } from "react-router-dom";
const $ = require("jquery");
require("datatables.net");
const SystemUsers = ({ data }) => {
  const tableRef = useRef(null); 
  const [isLoading, setIsLoading] = useState(true);
  const [createSystemUserModal, setCreateSystemUserModal] = useState(false);
  const [editSystemUserModal, setEditSystemUserModal] = useState(false);
  const [editUserID, setEditUserID] = useState(false);
  const [viewSystemUserModal, setViewSystemUserModal] = useState(false);
  const viewSystemUserModalClose=()=>{setViewSystemUserModal(false)} 
  const [rerender, setRetender] = useState(true);
  const navigate = useNavigate(); 

  const createSystemUserModalClose=(rr=true)=>{
    setCreateSystemUserModal(false)
    if(rr){
      setRetender(!rerender)
    } 
  }
  const editSystemUserModalClose=(rr=true)=>{
    setEditSystemUserModal(false)
    if(rr){
      setRetender(!rerender)
    } 
  }
  useEffect(() => {
  if(!checkPermissions('system_users_page') || !checkPermissions('users_navigation')){ 
      navigate('/')
    }
  },[])
  useEffect(() => {
    // Initialize DataTable
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      serverMethod: "get",
      ajax: {
        url: `${getEnvUrl()}/admin/getSystemUserReport`,
        data:{from_date:'',to_date:''},
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      },
      columns: [
        { data: "sysuser_id" },
        { data: "name" },
        { data: "email" },
        // { data: "country_code" },
        { data: "mobile_number" },
        { data: "role" },
        { 
          data: null,
          title: 'Actions',
          render:  (data, type, row) => (
            `<div> 
            <span class="a-edit"><i class="bi bi-pencil-square"></i></span>  
            <span class="a-view"><i class="bi bi-eye-fill"></i></span>  
            <span class="a-delete"><i class="bi bi-trash-fill"></i></span>          
            </div>`
          )
            },
      ],
      createdRow: (row, data, dataIndex) => {  
        if(!checkPermissions('system_user_edit')){
          $(row).find('.a-edit').remove();
        }
        if(!checkPermissions('system_user_view')){
          $(row).find('.a-view').remove();
        }
        if(!checkPermissions('system_user_delete')){
          $(row).find('.a-delete').remove();
        }
        $(row).find('.a-edit').on('click', () => {setEditSystemUserModal(true)
          setEditUserID(data.sysuser_id)
        } );
        $(row).find('.a-view').on('click', () => {setViewSystemUserModal(true)
          setEditUserID(data.sysuser_id)
        } );
        $(row).find('.a-delete').on('click', () => {
          if(window.confirm('Are you sure you want to delete this user?')){
            deleteSystemUserByID(data.sysuser_id)
            .then((response) => {
            if (response.status===true) {
              toast.success(response.message)
              setRetender(!rerender)
            }else{
            toast.error(response.errorMessage)
            }
            })
            .catch((error) => {
            toast.error('Error deleting user:', error);
            });
          }     
        } );
      },
      'columnDefs': [ {
        'targets': [5], /* column index */
        'orderable': false, /* true or false */
     }],
     drawCallback: function(settings) {
      setIsLoading(false);
    },
      aaSorting: [[0, "desc"]]
    });

    return () => {
      // Destroy DataTable when component unmounts to avoid memory leaks
      table.destroy();
    };
  }, [data, rerender]);

  
  return (  
    <div> 
    <main id="main" className="main">
    <div className="pagetitle">
    <h1>System users</h1> 
    </div>
    <section className="section">
        <div className="row">
          <div className="col-lg-12">
          <div className="card p-10">
            {checkPermissions('system_user_create') && 
              <h5 className="card-title">
                  <button onClick={()=>setCreateSystemUserModal(true)}  type="button" class="btn btn-primary float-right">
                    + Add System user
                  </button>
                </h5>
              }
              {isLoading?<Loader />:"" }
                  <div className={isLoading?'card-body hide':'card-body'}> 
                    <table
                      className="table table-striped table-hover table-bordered no-footer dataTable"
                      width="100%"
                      ref={tableRef}
                    >
                      <thead>
                      <tr>
                      <th>User Id</th>
                      <th>Name</th>
                      <th>Email</th>
                      {/* <th>Country code</th> */}
                      <th>Mobile Number</th>
                      <th>Role</th>
                      <th>Action </th>
                      </tr>
                  </thead>
                    </table>
              </div>
            </div> 
            </div>
        </div>
      </section>
  </main>  
  {createSystemUserModal?<CreateSystemUser isShow={createSystemUserModal} close={createSystemUserModalClose} type="CREATE" />:''} 
  {editSystemUserModal?<CreateSystemUser isShow={editSystemUserModal} close={editSystemUserModalClose} editUserId={editUserID} type="EDIT"/>:''} 
  {viewSystemUserModal?<ViewSystemUser isShow={viewSystemUserModal} close={viewSystemUserModalClose} editUserId={editUserID}  />:''} 
 </div>
  );
};
export default SystemUsers;
 
    